export class TrendingSearchMiniEntity {
  id?: number
  name?: string | null
  channelId?: number | null
  channelName?: string | null
  createdAt?: string
}
